import { compose, branch, mapProps } from 'recompose'
import withContainer from './withContainer'
import withField from './withField'
import withMultiField from './withMultiField'
import { withFieldSubmit } from '../Form'

export const wrapField = WrapedComponent => compose(
	mapProps(({ validate, ...props }) => ({
		validate: typeof validate === 'function' ?
			(...args) => {
				const res = validate(...args)
				if(res !== null) {
					return res
				}
			} : null,
		...!props.field && { noForm: true },
		...props
	})),
	branch(
		({ noForm, field }) => (!noForm && field),
		withFieldSubmit
	),
	branch(
		({ multiField }) => multiField,
		withMultiField
	),
	branch(
		({ noForm, field }) => (!noForm && field),
		withField
	),
	withContainer
)(WrapedComponent)

export default wrapField
